import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { provinceMapData } from '../data/provinces';
import { defaultData } from '../data/defaultData';
import Province from './provinces';
import './iran-provinces-map.css';
var IranProvincesMap = function (_a) {
    var province = _a.province, provinceData = _a.provinceData, colorRange = _a.colorRange, selectedProvinceColor = _a.selectedProvinceColor, _b = _a.tooltipTitle, tooltipTitle = _b === void 0 ? '' : _b, _c = _a.width, width = _c === void 0 ? 500 : _c, _d = _a.textColor, textColor = _d === void 0 ? '#000' : _d, _e = _a.deactiveProvinceColor, deactiveProvinceColor = _e === void 0 ? '#e6e6e6' : _e, selectProvinceHandler = _a.selectProvinceHandler;
    var mapRef = useRef(null);
    var _f = useState(null), cityName = _f[0], setCityName = _f[1];
    var _g = useState({
        name: '',
        faName: '',
    }), selectedCity = _g[0], setSelectedCity = _g[1];
    var trimValue = function (text) {
        return text.trim();
    };
    var pathClickedHandle = function (pathName) {
        var selectedCityData = Object.values(provinceMapData)
            .flatMap(function (province) { return province; })
            .find(function (province) { return trimValue(province.cityFaName) === pathName; });
        setSelectedCity({
            faName: selectedCityData === null || selectedCityData === void 0 ? void 0 : selectedCityData.cityFaName,
            name: selectedCityData === null || selectedCityData === void 0 ? void 0 : selectedCityData.cityName,
        });
        selectProvinceHandler &&
            selectProvinceHandler({
                faName: selectedCityData === null || selectedCityData === void 0 ? void 0 : selectedCityData.cityFaName,
                name: selectedCityData === null || selectedCityData === void 0 ? void 0 : selectedCityData.cityName,
            });
    };
    var pathMouseOverHandler = function (event) {
        var path = event.target;
        var cityName = path.dataset.name;
        if (cityName) {
            setCityName(cityName);
        }
    };
    var findCityCount = function () {
        var _a, _b;
        return ((_b = (_a = provinceMapData[province].find(function (city) { return trimValue(city.cityFaName) === trimValue(cityName || ''); })) === null || _a === void 0 ? void 0 : _a.cityName) !== null && _b !== void 0 ? _b : '');
    };
    var badge = "\n    <div class='react-map-badge'>\n      <h2>".concat(cityName, "</h2>\n      <h3>\n      ").concat(selectedCity && (provinceData[findCityCount()] || defaultData[province][findCityCount()]), "\n      ").concat(tooltipTitle && "<span>".concat(tooltipTitle, "</span>"), "\n      </h3>\n    </div>\n  ");
    var setPathBackgrounds = function (svg) {
        var polygons = svg.querySelectorAll('polygon');
        var polylines = svg.querySelectorAll('polyline');
        var paths = svg.querySelectorAll('path');
        var mergedData = __assign(__assign({}, defaultData[province]), provinceData);
        var values = Object.values(mergedData);
        var min = Math.min.apply(Math, values);
        var max = Math.max.apply(Math, values);
        var setColorHandler = function (element) {
            var selectedCityData = Object.values(provinceMapData)
                .flatMap(function (province) { return province; })
                .find(function (city) { return trimValue(city.cityFaName) === element.getAttribute('data-name'); });
            if (selectedCityData) {
                var count = mergedData[trimValue(selectedCityData.cityName)] || 0;
                if (count === 0) {
                    element.style.fill = deactiveProvinceColor;
                }
                else {
                    if (min !== max) {
                        var alpha = Math.max(0.1, Math.min(1, (count - min) / (max - min)));
                        var usageColor = "rgba(".concat(colorRange, ", ").concat(alpha, ")");
                        element.style.fill = usageColor;
                    }
                    else {
                        var usageColor = "rgba(".concat(colorRange, ", ").concat(min > 0 ? 1 : 0.1, ")");
                        element.style.fill = usageColor;
                    }
                }
            }
            if (element.getAttribute('data-name') === trimValue(selectedCity.faName || '') && selectedProvinceColor) {
                element.style.fill = selectedProvinceColor;
            }
        };
        paths.forEach(function (path) {
            setColorHandler(path);
        });
        polygons.forEach(function (polygon) {
            setColorHandler(polygon);
        });
        polylines.forEach(function (polyline) {
            setColorHandler(polyline);
        });
    };
    useEffect(function () {
        if (mapRef.current) {
            var mapElement = mapRef.current;
            if (mapElement !== null && typeof mapElement === 'object') {
                setPathBackgrounds(mapElement);
            }
        }
    }, [mapRef, selectedCity]);
    return (React.createElement("div", { className: 'iran-provinces-map-wrapper' },
        React.createElement(Province, { province: province, mapRef: mapRef, pathClickedHandle: pathClickedHandle, pathMouseOverHandler: pathMouseOverHandler, width: width, textColor: textColor }),
        React.createElement(Tooltip, { id: 'iran-provinces-map-tooltip', html: badge, variant: 'light', float: true, style: { padding: 0 } })));
};
export default IranProvincesMap;
//# sourceMappingURL=IranProvincesMap.js.map